import React, { useEffect, useState } from "react";
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';
import { useRef } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { obtenerDetalleSolicitud } from "../services/solicitudesService";

export default function DetalleSolicitud() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [solicitud, setSolicitud] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toastShown = useRef(false);

  useEffect(() => {
    const fetchDetalle = async () => {
      try {
        const data = await obtenerDetalleSolicitud(id);
        setSolicitud(data);
      } catch (err) {
        setError(err.message || 'Error al cargar el detalle de la solicitud');
      } finally {
        setLoading(false);
      }
    };
    fetchDetalle();
  }, [id]);

  useEffect(() => {
    if (!toastShown.current && !loading) {
      if (solicitud) {
        toast.success('Detalle cargado correctamente', { autoClose: 2000 });
        toastShown.current = true;
      } else if (error) {
        toast.error('Error al cargar el detalle de la solicitud', { autoClose: 3000 });
        toastShown.current = true;
      }
    }
  }, [loading, solicitud, error]);

  const mostrarDato = dato => (dato === null || dato === undefined || dato === "" || dato === 0) ? <span className="fst-italic text-muted">&lt;No indicado&gt;</span> : dato;

  return (
  <motion.div className="container my-5" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
      <h2 className="mb-4 text-primary">Detalle de la Solicitud</h2>
      {loading && <div className="alert alert-info">Cargando...</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      {solicitud && (
        <ul className="list-group mb-4">
          <li className="list-group-item"><b>Consecutivo de oficio de la solicitud:</b> {mostrarDato(solicitud.consecutivoOficioSolicitud)}</li>
          <li className="list-group-item"><b>Documento de respuesta:</b> {mostrarDato(solicitud.documentoRespuestas)}</li>
          <li className="list-group-item"><b>Documento de inicio:</b> {mostrarDato(solicitud.documentoInicio)}</li>
          <li className="list-group-item"><b>Título de la solicitud:</b> {mostrarDato(solicitud.tituloSolicitud)}</li>
          <li className="list-group-item"><b>Descripción:</b> {mostrarDato(solicitud.descripcion)}</li>
          <li className="list-group-item"><b>Representante:</b> {mostrarDato(solicitud.nombreRepresentante)}</li>
          <li className="list-group-item"><b>Observaciones:</b> {mostrarDato(solicitud.observaciones)}</li>
          <li className="list-group-item"><b>Estado de la solicitud:</b> {mostrarDato(solicitud.estadoSolicitud)}</li>
          <li className="list-group-item"><b>Fecha de ingreso:</b> {mostrarDato(solicitud.fechaIngreso)}</li>
          <li className="list-group-item"><b>Fecha de respuesta:</b> {mostrarDato(solicitud.fechaRespuesta)}</li>
          <li className="list-group-item"><b>Fecha de inicio:</b> {mostrarDato(solicitud.fechaInicio)}</li>
          <li className="list-group-item"><b>Fecha de vencimiento de la publicación:</b> {mostrarDato(solicitud.fechaVencimientoPublicacion)}</li>
        </ul>
      )}
      <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>Regresar</button>
      <button className="btn btn-primary" onClick={() => navigate(`/participar/${id}`)}>Participar</button>
  </motion.div>
  );
}
